import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-warning',
  templateUrl: './time-warning.component.html',
  styleUrls: ['./time-warning.component.scss']
})
export class TimeWarningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
